import { memo, useState } from 'react';
import { ImageErrorEventData } from 'react-native';
import { Image } from '@betty/moonlight';
import { CommunityJackpotImageProps } from './CommunityJackpotImage.types';

function CommunityJackpotImage({
  url,
  fallback,
  ...rest
}: CommunityJackpotImageProps) {
  const [error, setError] = useState<ImageErrorEventData>();

  return (
    <Image name={error && fallback} source={url} onError={setError} {...rest} />
  );
}

export default memo(CommunityJackpotImage);
